import React from 'react'
import LearningPath from '../../../modules/ELearning/LearningPath'

const ElearningLearningPathPage = () => {
  return <LearningPath />
}

export default ElearningLearningPathPage
